import { BaseConfig } from '../ServiceConfig';
import { PSConfiguration } from './PSConfig';

export interface HestiaConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.HestiaServiceConfigData';
  url: string;
  bffUrl: string;
  paymentConfig: PSConfiguration;
}

export const HestiaConfigurationFields: (keyof HestiaConfiguration)[] = [
  'url',
  'bffUrl',
  'paymentConfig',
];

export const BlankHestiaConfiguration: HestiaConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.HestiaServiceConfigData',
} as HestiaConfiguration;
